import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { functionalitiesHelper, isSameOrBeforeDate } from '../../../../utils/functionalitiesHelper'
import { useDailyAttendance } from './hooks/useDailyAttendance'
import { getDailyAttendanceDetailed } from '../../../../services/dashboard'
import { getDaysInMonth, mergeAttendanceDaysWithValues } from '../../../../utils/constants'

import BackButton from '../../../../components/BackButton'
import ExpandableCard from '../../../../components/Card/ExpandableCard'
import DateHeader from '../../../../pages/Professionals/Dashboard/components/DateHeader'

import { INITIAL_VALUE, ITEMS_PER_PAGE } from './constants'
import { ReactComponent as GreenCheck } from '../../../../assets/icons/green-check.svg'
import { ReactComponent as ScissorsIcon } from '../../../../assets/icons/scissors-avatar.svg'
import { ReactComponent as ScissorsIconGray } from '../../../../assets/icons/scissors-gray-avatar.svg'

import * as S from './styles'
import { capitalize, formatDate, formatCpf } from '../../../../utils/formatters'

const DailyAttendance = () => {
  const { getDates } = functionalitiesHelper
  const { search } = useLocation()
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const { date, sameDate } = queryString.parse(search, { parseBooleans: true })
  const { monthAndYear, day, month, year, fullDate } = getDates(date)
  const attedanceDaysList = useDailyAttendance(professional.id, fullDate, sameDate)
  const daysWithoutValues = getDaysInMonth(month, year)
  const [displayedItems, setdisplayedItems] = useState(ITEMS_PER_PAGE)
  const [detailedDays, setDetailedDays] = useState([])
  const loading = !attedanceDaysList
  const [fetchingDetailedAttendance, setFetchingDetailedAttendance] = useState(false)

  const header = {
    title: monthAndYear,
    subtitle: `Informações ${sameDate ? 'deste mês ' : ''} até o dia ${day}`,
    loading
  }

  const handleLoadMore = () => {
    setdisplayedItems(prevItems => prevItems + ITEMS_PER_PAGE)
  }

  useEffect(() => {
    if (detailedDays.length <= 0 && attedanceDaysList) {
      const mergedDays = mergeAttendanceDaysWithValues(daysWithoutValues, attedanceDaysList)
      if (sameDate) {
        const filteredCurrentDate = isSameOrBeforeDate(mergedDays, date)
        return setDetailedDays(filteredCurrentDate)
      }
      setDetailedDays(mergedDays)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attedanceDaysList])

  const handleGetAttendanceDetailed = async (item, index) => {
    let data
    if (!item.isMounted) {
      setFetchingDetailedAttendance(index)
      data = await getDailyAttendanceDetailed(professional.id, item.day)
      setDetailedDays(prevDetailedDays => {
        return prevDetailedDays.map(d => (d.day === item.day ? { ...item, attendances: data, isMounted: true } : d))
      })
      setFetchingDetailedAttendance(null)
    }
  }

  return (
    <>
      <BackButton text='Histórico de atendimentos' />
      <S.Container>
        {loading && !fetchingDetailedAttendance
          ? <>
            <S.SkeletonCard type='title' />
            <S.SkeletonCard type='subtitle' />
            {Array(ITEMS_PER_PAGE).fill().map((_, index) => <S.SkeletonCard type='card' key={'fill-' + index} />)}
          </>
          : <>
            <DateHeader {...header} />
            {detailedDays && detailedDays.slice(INITIAL_VALUE, displayedItems).map((item, index) => {
              const hasAttendance = item.isNotEmpty
              return <S.CardContainer
                key={'day-' + index}
                onClick={() => hasAttendance && handleGetAttendanceDetailed(item, index)}
                loading={index === fetchingDetailedAttendance}
              >
                <ExpandableCard
                  icon={hasAttendance ? <ScissorsIcon /> : <ScissorsIconGray />}
                  title={`Dia ${formatDate({ date: item?.day, format: 'DD' })}`} subtitle={capitalize(formatDate({ date: item?.day, format: 'dddd' }))}
                  loading={index === fetchingDetailedAttendance}
                >
                  {hasAttendance
                    ? item.attendances?.map((attendance, index) => {
                      const isOverbook = attendance?.type === 'OVERBOOK'
                      const attendanceCpf = attendance.userCpf ? formatCpf(attendance.userCpf) : 'Não preenchido'
                      const mergedServicesName = [attendance.service, ...(attendance.additionalServices) ? attendance.additionalServices : []].map(service => service.name).sort()
                      let attendanceServicesName
                      if (mergedServicesName.length > 1) {
                        const last = mergedServicesName.pop()
                        attendanceServicesName = mergedServicesName.join(', ') + ' e ' + last
                      } else {
                        attendanceServicesName = mergedServicesName[0]
                      }

                      return (
                        <S.BlockContainer key={attendance.id + '-' + index}>
                          <hr />
                          <S.Block>
                            <S.Tag fill={!isOverbook}><GreenCheck />{isOverbook ? 'Encaixe' : 'Agendamento'} das {formatDate({ date: attendance.date, format: 'HH:mm' })}</S.Tag>
                            <S.Label><span> Serviços realizados: </span> {attendanceServicesName}</S.Label>
                            <S.Label><span>Tutor: </span> {attendance?.userName} | CPF: {attendanceCpf}</S.Label>
                            <S.Label><span>Pet: </span> {attendance?.pet?.name} | {attendance?.pet?.breed?.name}</S.Label>
                            <S.Label><span>Realizado por: </span> {attendance?.professional?.name}</S.Label>
                          </S.Block>
                        </S.BlockContainer>
                      )
                    })
                    : <>
                      {sameDate && item.day === date
                        ? <S.Block>
                          <hr />
                          <S.Title>Nenhum atendimento até o momento</S.Title>
                          <S.Label>Nenhum agendamento ou encaixe foi finalizado até o momento.</S.Label>
                        </S.Block>
                        : <S.Block>
                          <hr />
                          <S.Title>Nenhum atendimento neste dia</S.Title>
                          <S.Label>Neste dia não foi realizado nenhum agendamento ou encaixe.</S.Label>
                        </S.Block>
                      }
                    </>}
                </ExpandableCard>
              </S.CardContainer>
            })}
            {displayedItems < detailedDays?.length && (
              <S.LoadMoreButton onClick={handleLoadMore} outline>Carregar mais</S.LoadMoreButton>
            )}
          </>
        }
      </S.Container >
    </>
  )
}

export default DailyAttendance
